import { render, staticRenderFns } from "./Pullchick.vue?vue&type=template&id=5934e816&"
import script from "./Pullchick.vue?vue&type=script&lang=js&"
export * from "./Pullchick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports